import PageHelper from './pageHelper'
import omit from 'object.omit';

import {utils_tool} from '@/tool';

let {log, isType} = utils_tool;

/**
 * 格式化分页数据
 * @param {*} data
 * @param {*} format
 */
const formatPage = (data, format) => {
  let r = PageHelper.create()
  for (let key in format) {
    if (data[format[key]]) {
      r[key] = data[format[key]]
    }
  }
  return r;
}

/**
 * 逆向格式化分页数据
 * @param {*} data
 * @param {*} format
 */
const reverseFormatPage = (data, format) => {
  let r = {};
  for (let key in data) {
    let e = format[key];
    if (e) {
      r[e] = data[key]
    } else {
      r[key] = data[key]
    }
  }
  if (data['filters']) {
    r = {...r, ...data['filters']}
  }
  r = omit(r, ['list', 'headList', 'filters', 'records', 'pages', 'reasonable', 'total', 'orders'])
  return r;
}

/**
 * 构造columns，处理替换属性 {wizReplaceData:'key',default:{}}
 * @param {*} columns
 * @param {*} _datas
 * @param {*} defaultType
 */
const _buildColumns = (columns, _datas, defaultType = [],) => {
  let data;
  if (isType(columns, 'Object')) {
    data = {};
    if (columns['wizReplaceData']) {
      let d = _datas && _datas[columns['wizReplaceData']];
      if (d) {
        if (d['@isDefault'] === 'Yes') {
          data = columns['defaultType'] ? columns['defaultType'] : []
        } else {
          data = d['data'] ? d['data'] : []
        }
      } else {
        data = columns['defaultType'] ? columns['defaultType'] : []
      }
    } else {
      for (let key in columns) {
        data[key] = _buildColumns(columns[key], _datas)
      }
    }
  } else if (isType(columns, 'Array')) {
    data = [];
    columns.forEach(e => {
      data.push(_buildColumns(e, _datas))
    });
  } else {
    data = columns;
  }

  return data;
}

/**
 * 构建按钮功能
 * @param {*} buttons
 */
const _buildButtons = (buttons, typeMethod) => {
  if (isType(buttons, 'Array')) {
    let r = [];
    buttons.forEach(btn => {
      r.push(btn, typeMethod);
    });
  } else if (isType(buttons, 'Object')) {
    return _buildBtn(buttons)
  }
}

const _buildBtn = (btn, typeMethod) => {
  if (btn && isType(btn, 'Object')) {
    let onClick = btn['onClick']
    if (isType(onClick, 'Object')) {
      let {type, ...other} = onClick;
      if (type) {
        typeMethod && typeMethod(type, other)
      } else {
        log.error('wizTabListNew: _buildBtn 自定义btn需要传入type')
      }
    } else {
      return btn
    }
  } else {
    log.error('wizTabListNew: _buildBtn 按钮参数必须是一个对象')
    return null;
  }
}

/**
 * 构建查看的参数
 * @param {*} obj
 * @param {*} typeArr
 */
const _buildLookModalProps = (modalFrom, _this) => {
  //按钮
  delete modalFrom['onCancel']
  modalFrom['onSubmit'] = () => {
    _this.setState({
      record: null,
      visible: false,
      look: false
    });
  }
  modalFrom['_onCancel'] = () => {
    _this.setState({
      record: null,
      visible: false,
      look: false
    });
  }
  //from禁用
  if (modalFrom['columns'] && modalFrom['columns'].length > 0) {
    modalFrom['columns'].forEach(val => {
      if (val && val['formItem']) {
        val['formItem']['disabled'] = true
      }
    });
  }
  return modalFrom;
}


/**
 * 构建查看的参数
 * @param {*} obj
 * @param {*} typeArr
 */
const _buildSideBarLookModalProps = (modalFrom, _this) => {
  //按钮
  delete modalFrom['onCancel']
  modalFrom['onSubmit'] = () => {
    _this.setState({
      visibleTreeEntity: false,
      look: false
    });
  }
  modalFrom['_onCancel'] = () => {
    _this.setState({
      visibleTreeEntity: false,
      look: false
    });
  }
  //from禁用
  if (modalFrom['columns'] && modalFrom['columns'].length > 0) {
    modalFrom['columns'].forEach(val => {
      if (val && val['formItem']) {
        val['formItem']['disabled'] = true
      }
    });
  }
  return modalFrom;
}

/**
 * 格式化删除的参数 格式为 {ids:[ ... ]}
 */
const _formatDeleteRecord = (arr) => {
  let ids = [];
  arr.forEach(e => {
    if (e['rowKey']) {
      ids.push(e['rowKey']);
    }
  });
  return {ids}
}

export {formatPage, reverseFormatPage, _buildColumns, _buildButtons, _buildLookModalProps,_buildSideBarLookModalProps, _formatDeleteRecord}
